import { gql } from '@apollo/client';

export const MUTATE_COMPENSATION_CODES = gql`
    mutation MyMutation($payload: STKAlocateVoucherRequestParams!) {
        stkAlocateVoucher(payload: $payload) {
            code
            message
            data
        }
    }
`;

export const MUTATE_OFFLINE_MODULE = gql`
    mutation MyMutation($payload: StkOfflineModuleInput!) {
        stkOfflineModule(payload: $payload) {
            statusCode
            code
            message
            data
        }
    }
`;

export const MUTATE_RESEND_COMPENSATION_CODES = `
    mutation MyMutation($payload: resendEmailRequestParams!) {
        resendEmail(payload: $payload) {
            message
            success
            voucherIds
        }
    }
`;

export const MUTATE_UPDATE_EMAIL_ADDRESS = `
    mutation MyMutation($payload: updateAllVoucherEmailParams!) {
        stkHistoryEmail(payload: $payload) {
            requestId
            voucherItems
            statusCode
            statusMessage
            code
            message
        }
  }
`;